import React, { Component } from "react";

class Popup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            motivoId: 0,
            esValido: false
        }
        this.validarMotivo = this.validarMotivo.bind(this);
        this.onClickEliminarAjuste = this.onClickEliminarAjuste.bind(this);
        this.onClickConfirmar = this.onClickConfirmar.bind(this);
    }

    /**
     * 
     */
    validarMotivo() {
        if (this.state.motivoId == 0 && this.state.validaCambo) {
            this.setState({ esValido: false });
        } else {
            this.props.confirmar((!this.state.validaCambo ? undefined : this.state.motivoId));
        }
    }
    /**
     * 
     */
    componentDidMount() {
        const { clave } = this.props;
        /*lamentablmente necesario para evitar que se cierre el dropdown cuando el usuario hace click sobre el contenido*/
        $(`#${clave} .dropdown-menu`).on({
            "click": function (e) {
                /*si no hay que ejecutar entonces bloqueo la accion*/
                if (e.target.dataset.ejecutar == "true") {
                    /*validar que hacer en caso de ejecutar*/
                    if (e.target.dataset.motivo == "false") {
                        e.stopPropagation();
                    }
                } else {
                    e.stopPropagation();
                }
            }
        });
    }

    onClickEliminarAjuste(ajuste) {
        this.props.eliminar(ajuste, this.props.usuarioModif);
    }

    onClickConfirmar(ajuste, estado) {
        this.props.getCodigo(ajuste, estado, this.props.ajusteEstados, this.props.cargoEstados);
        // this.props.confirmar(ajuste, estado, this.props.ajusteEstados, this.props.cargoEstados);
    }
    /**
     * 
     */
    render() {
        /*Atributos*/
        const { children, clave, motivos, titulo, mensajeError, tituloButton1, tituloButton2, ajuste } = this.props;

        let esEliminar = !tituloButton1;
        let classButtonEliminar = esEliminar ? "btn btn-cta" : "btn btn-default";
        let titleButtonEliminar = esEliminar ? "Aceptar" : "Cerrar";
        let styleContainer = esEliminar ? {paddingTop: "10px", paddingBottom: "10px", textAlign: "right"} : {paddingTop: "10px", paddingBottom: "10px", textAlign: "center"}
        let ajusteEliminarConfirmar = undefined;

        return (
            <div className="popup-tarjetas-bloqueo" style={{display: "inline-block"}}>
                <div className="dropdown" id={clave}>
                    {children}
                    <ul className="dropdown-menu dropdown-menu-right" style={{width: "500px"}}>
                        <div className="top-popup" style={{padding: 0, paddingTop: "10px"}}>
                            <li>
                                <label className="label-primary" style={{marginLeft: "28px", marginBottom: "0"}}>{titulo}</label>
                            </li>
                           {(this.state.validaCambo && this.state.esValido == false) &&
                                <li className="top-separator-xxs"><label className="error">{mensajeError}</label></li>}

                            <div style={{backgroundColor: "#d8d8d8"}}>
                                <li className="top-separator-xxs" style={styleContainer}>
                                    {tituloButton1 &&
                                        <div style={{display: "inline-block", marginRight: "28px"}}>
                                            <button type="button"
                                                className="btn btn-cta"
                                                style={{height: "35px", width: "150px"}}
                                                data-ejecutar={true}
                                                data-motivo={(this.state.validaCambo ? this.state.esValido : true)}
                                                onClick={() => this.onClickConfirmar(ajuste, tituloButton1)}>{tituloButton1}</button>
                                        </div>}
                                    {tituloButton2 &&
                                    <div style={{display: "inline-block", marginRight: "28px"}}>
                                        <button type="button"
                                            className="btn btn-default"
                                            style={{height: "35px", width: "150px"}}
                                            data-ejecutar={true}
                                            data-motivo={(this.state.validaCambo ? this.state.esValido : true)}
                                            onClick={() => this.onClickConfirmar(ajuste, tituloButton2)}>{tituloButton2}</button>
                                    </div>}
                                    <div className="text-right" style={{display: "inline-block"}}>
                                        <button type="button"
                                            className={classButtonEliminar}
                                            style={{height: "35px", width: "100px"}}
                                            data-ejecutar={true}
                                            data-motivo={(this.state.validaCambo ? this.state.esValido : true)}
                                            onClick={esEliminar ? () => this.onClickEliminarAjuste(ajuste) : null}>{titleButtonEliminar}</button>
                                    </div>
                                    {esEliminar &&
                                    <div style={{display: "inline-block", marginRight: "28px"}}>
                                        <button type="button"
                                            className="btn btn-default"
                                            style={{height: "35px", width: "100px", marginLeft: "20px"}}
                                            data-ejecutar={true}
                                            data-motivo={(this.state.validaCambo ? this.state.esValido : true)}
                                            onClick={null}>Cancelar</button>
                                    </div>}
                                </li>
                            </div>
                        </div>
                    </ul>
                </div>
            </div>
        );
    }
}

export default Popup;